import { Skeleton, Stack } from '@mui/material';

export const ProductDetailSkeleton = () => {
  return (
    <Stack marginTop={6} direction={'row'} gap={2}>
      <Skeleton height={'60vh'} width={'42vw'} sx={{ transform: 'unset' }} />
      <Stack gap={3} marginTop={3}>
        <Skeleton variant="text" height={50} width={'22vw'} sx={{ transform: 'unset' }} />
        <Skeleton variant="text" height={20} width={'15vw'} sx={{ transform: 'unset' }} />
        <Skeleton variant="text" height={20} width={'25vw'} sx={{ transform: 'unset' }} />
        <Skeleton variant="text" height={20} width={'23vw'} sx={{ transform: 'unset' }} />
        <Skeleton variant="text" height={20} width={'15vw'} sx={{ transform: 'unset' }} />
        <Skeleton variant="text" height={20} width={'21vw'} sx={{ transform: 'unset' }} />
        <Skeleton variant="text" height={20} width={'20vw'} sx={{ transform: 'unset' }} />
        <Skeleton variant="text" height={20} width={'15vw'} sx={{ transform: 'unset' }} />
        <Skeleton variant="text" height={20} width={'28vw'} sx={{ transform: 'unset' }} />
      </Stack>
    </Stack>
  );
};
